module.exports = __webpack_public_path__ + "static/media/location_destination_icon_dark.13a71bb5.svg";